import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import LegacyApp from "./App";
import V2App from "./App.jsx";
import UiFeedbackLauncher from "./UiFeedbackLauncher";
import { isV2Path } from "../../universal/v2Routes";
import { installRedditPixelClientTracking } from "../../universal/redditPixel";

export default function AppShellByRoute(props) {
    const location = useLocation();
    const history = useHistory();
    const isV2Route = isV2Path(location.pathname);
    const AppComponent = isV2Route ? V2App : LegacyApp;

    React.useEffect(() => {
        if (typeof document === "undefined") {
            return undefined;
        }

        document.body.classList.toggle("ouro-v2-route", isV2Route);

        return () => {
            document.body.classList.remove("ouro-v2-route");
        };
    }, [isV2Route]);

    React.useEffect(() => {
        return installRedditPixelClientTracking({
            search: location.search,
            pathname: location.pathname,
            hash: location.hash,
            replaceSearch: (nextLocation) => {
                history.replace(nextLocation);
            },
        });
    }, [history, location.hash, location.pathname, location.search]);

    return (
        <>
            <AppComponent {...props} />
            <UiFeedbackLauncher />
        </>
    );
}
